import React from 'react';
import ProductCard from './ProductCard';
import { getFeaturedProducts } from '../data/products';
import './ProductList.css';

const ProductList = () => {
  const featuredProducts = getFeaturedProducts();

  const handleWhatsAppInquiry = (product) => {
    const message = encodeURIComponent(
      `Hello! I'm interested in the ${product.name} (${product.category}). Can you provide more information about this product?`
    );
    window.open(`https://wa.me/923427374035?text=${message}`, '_blank');
  };

  return (
    <div className="product-list">
      <div className="products-grid">
        {featuredProducts.map(product => (
          <ProductCard 
            key={product.id}
            product={product}
            onInquiry={() => handleWhatsAppInquiry(product)}
          />
        ))}
      </div>
    </div>
  );
};

export default ProductList;
